<div class="w-full max-w-screen-xl mx-auto">
    <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 w-full min-w-0 mt-2">
        <!-- Github issues summary -->
        <div class="sm:col-span-2 md:col-span-4 flex flex-col flex-auto p-6 bg-card shadow rounded-2xl overflow-hidden">
            <div class="flex flex-col sm:flex-row items-start justify-between">
                <div class="text-lg font-medium tracking-tight leading-6 truncate">
                    Carga masiva de productos
                </div>
            </div>
            <div class="grid grid-cols-1 lg:grid-cols-1 grid-flow-row gap-6 w-full mt-8 sm:mt-4">
                <div class="row">

                    <app-carga-masiva [urlTemplate]="urlTemplate" [urlApiCatalogo]="urlApiCatalogo" [fuente]="fuente"
                        [columnas]="columnas" [acciones]="acciones" [urlApi]="urlApi" (response)="response($event)">
                    </app-carga-masiva>
                </div>
            </div>
        </div>
    </div>
</div>